import { ComponentProps } from 'react';
import { Card } from '@startuptools/ui/Card';
import { CardContent } from '@startuptools/ui/CardContent';
import { Typography } from '@startuptools/ui/Typography';
import { Stack } from '@startuptools/ui/Stack';
import { useTheme } from '@startuptools/ui/Theme';
import LaunchIcon from '@mui/icons-material/Launch';
import Icon from '@mui/material/Icon';
import { TemplatesButton } from './TemplatesButton';
import useMediaQuery from '@mui/material/useMediaQuery';

export const TemplatesCard = ({
  title,
  iconName,
  buttons,
  referToUrl,
  showAnchor,
}: {
  title: string;
  iconName: string;
  buttons: ComponentProps<typeof TemplatesButton>[];
  referToUrl: string;
  showAnchor?: boolean;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Card
      sx={{
        minWidth: '21.9375rem',
        maxWidth: isMobile ? '80%' : 'auto',
        width: 'fit-content',
        borderRadius: '8px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 4px 32px rgba(0, 0, 0, 0.12)',
      }}
    >
      <CardContent
        sx={{
          padding: '2rem 2.5rem',
          width: 'auto',
        }}
      >
        <Stack
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'between',
          }}
          spacing={2}
          direction={'row'}
        >
          <Icon
            className={`material-icons-round`}
            sx={{ color: theme.palette.primary[500], width: '2rem', height: '2rem' }}
            fontSize="large"
            aria-label="Launch"
          >
            {iconName}
          </Icon>
          <Typography fontSize="1rem" whiteSpace={'nowrap'}>
            {title}
          </Typography>
          {showAnchor && (
            <a
              href={referToUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-current no-underline hover:scale-105 duration-200"
            >
              <LaunchIcon fontSize="inherit" sx={{ margin: '0px 0px -0.125rem 0px', padding: 0 }} />
            </a>
          )}
        </Stack>
        <Stack
          spacing={2}
          direction="column"
          sx={{
            marginTop: '1rem',
          }}
        >
          {buttons.map(buttonProps => (
            <TemplatesButton key={buttonProps.url[0]} {...buttonProps} />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
